import { render } from "./SectionTech.vue?vue&type=template&id=7de98992&scoped=true"
import script from "./SectionTech.vue?vue&type=script&lang=js"
export * from "./SectionTech.vue?vue&type=script&lang=js"

import "./SectionTech.vue?vue&type=style&index=0&id=7de98992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de98992"]])

export default __exports__